module.exports = __webpack_public_path__ + "static_pc/img/21.4f8c6e7f.jpg";